import {
  CommandResultStatus,
  TcsEntity,
  TcsEntityType,
} from 'src/graphql/generated/graphql.generated';

export interface CommandResult<TData = any, TCommand = any> {
  status: CommandResultStatus;
  command: TCommand;
  data: TData;
  errors: {
    message: string;
    code: number;
  }[];
  entities?: Record<TcsEntityType, TcsEntity[]>;
  emittedEvents: any[];
}

export class CommandResultError extends Error {
  constructor(public readonly command: string, public readonly result: CommandResult) {
    super(
      `${command} command failed: ` +
        `${result.errors[0] != null ? result.errors[0].message : 'unknown error'}`,
    );
    // @ts-ignore
    Error.captureStackTrace(this, CommandResultError);

    // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
    // May be possible to remove when we can downlevel to ES6 or higher instead of ES5
    Object.setPrototypeOf(this, CommandResultError.prototype);
  }

  get userErrors(): string[] {
    return this.result.errors.filter((e) => e.code >= 4000 && e.code < 5000).map((e) => e.message);
  }
}
